import { CONSUME_INVITED_SITTER_TOKEN_MUTATION } from '@/graphql/backup_care/mutations';
import { setupApollo } from '@/lib/apollo_setup';
import { deleteDomainCookie, writeDomainCookie } from '@/lib/domain_cookie';

export function removeInvitedSitterCachedData() {
  deleteDomainCookie('interviewRequestId');
  deleteDomainCookie('invitedSitterToken');
  deleteDomainCookie('invitedSitterId');
}

export async function consumeInvitedSitterToken(interviewRequestId, invitedSitterToken, invitedSitterId) {
  const apolloProvider = setupApollo();

  await apolloProvider.defaultClient
    .mutate({
      mutation: CONSUME_INVITED_SITTER_TOKEN_MUTATION,
      variables: { interviewRequestId, invitedSitterToken, invitedSitterId },
    })
    .then((res) => {
      return res.data.success;
    })
    .catch((error: any) => {
      console.error('Error in consume invited sitter token mutation:', error); // eslint-disable-line no-console
      throw new Error('Failed to consume invited sitter token');
    });
}

export function cacheInvitedSitterData(interviewRequestId, invitedSitterToken, invitedSitterId) {
  writeDomainCookie('interviewRequestId', interviewRequestId);
  writeDomainCookie('invitedSitterToken', invitedSitterToken);
  writeDomainCookie('invitedSitterId', invitedSitterId);
}
